import { fmtListDate } from './list-row-classes';

const KIND_LABEL: Record<string, string> = {
  general: 'Document',
  course: 'Cours',
  exercice_sheet: 'Exercices',
  exam: 'Évaluation',
};

export function displayTitle(doc: { title: string | null | undefined; kind: string; created_at: string }): string {
  const title = doc.title?.trim();
  if (title) return title;
  const label = KIND_LABEL[doc.kind] ?? 'Document';
  return `${label} du ${fmtListDate(doc.created_at)}`;
}
